import React from 'react';

import { AsaphButton } from '@/components/shared/Button';
import { Logo } from '@/components/shared/Logo';

import styles from './ComingSoon.module.scss';

export const ComingSoon: React.FC = () => {
	const handleClick = () =>
		window.open('https://app.getacute.io/v/asaph/', '_blank')?.focus();

	return (
		<div className={styles['coming-soon']}>
			<div className={styles['coming-soon__wrapper']}>
				<div className={styles['coming-soon__logo']}>
					<Logo centered />
				</div>
				<div className="vsb-10" />
				<div className={styles['coming-soon__content-text']}>
					This feature is coming soon to our roadmap. Want it sooner?
					Upvote it here!
				</div>
				<div className="vsb-30" />
				<AsaphButton
					color="blue"
					label="Go to feature roadmap"
					onClick={handleClick}
					fullWidth
				/>
			</div>
		</div>
	);
};
